import React, { useState, useRef, useEffect } from 'react';
import {BiSolidEraser} from 'react-icons/bi'
import {ImBin} from 'react-icons/im'
import "./Paint.css";
import color from '../../utils/color';

const Paint = (props) => {
  const MirrorConnection = props.MirrorConnection;
  const canvasRef = useRef(null);
  const [cursor, setCursor] = useState('default');
  const [selectedColor, setSelectedColor] = useState('red');
  const [isDrawing, setIsDrawing] = useState(false);
  const [prevPosition, setPrevPosition] = useState({ x: 0, y: 0 });
  document.body.style.backgroundColor = "white";
  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    handleEraser()
    handleColorChange('red')
  };
  const handleEraser = () => {
    setSelectedColor('white');
    const canvas = canvasRef.current;
    canvasRef.current.classList.add('eraser-cursor'); 
    const context = canvas.getContext('2d');
    context.lineWidth = 100;    
  };  
  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    const draw = (x, y) => {
      if (!isDrawing) return;

      if (selectedColor === 'white') {
        // Use the eraser
        context.fillStyle = 'white';
        context.fillRect(x - 10, y - 10, 20, 20); // Adjust the size as needed
      } else {
        canvasRef.current.classList.remove('eraser-cursor'); 
        context.strokeStyle = selectedColor;
        context.lineWidth = 5;
        context.lineCap = 'round';
        context.beginPath();
        context.moveTo(prevPosition.x, prevPosition.y);
        context.lineTo(x, y);
        context.stroke();
        context.closePath();
        setPrevPosition({ x, y });
      }
    };
    const handleMouseDown = (e) => {
      setIsDrawing(true);
      setPrevPosition({
        x: e.clientX - canvas.getBoundingClientRect().left,
        y: e.clientY - canvas.getBoundingClientRect().top,
      });
    };

    const handleMouseUp = () => {
      setIsDrawing(false);
    };

    const handleMouseMove = (e) => {
      draw(e.clientX - canvas.getBoundingClientRect().left, e.clientY - canvas.getBoundingClientRect().top);
    };
    // const ws = new WebSocket('wss://localhost:9004');
    canvas.toBlob((blob) => {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        MirrorConnection._socket.send(reader.result)
      }
    })
    canvas.addEventListener('mousedown', handleMouseDown);
    canvas.addEventListener('mouseup', handleMouseUp);
    canvas.addEventListener('mousemove', handleMouseMove);

    return () => {
      canvas.removeEventListener('mousedown', handleMouseDown);
      canvas.removeEventListener('mouseup', handleMouseUp);
      canvas.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isDrawing, selectedColor, prevPosition]);
  const rainbowColors = ['red', 'orange', 'yellow', 'green', 'blue', 'indigo', 'violet'];
  const handleColorChange = (color) => {
    setSelectedColor(color);
  };
  return (
    <div className='container'>
      <div className="buttonContainer">
        <div className="colorButtonContainer">
          {rainbowColors.map((color) => (
            <button
            className='colorBtn'
            key={color}
            style={{ background: color }}
            onClick={() => handleColorChange(color)}
            ></button>
            ))}
        </div>
        <div className='actionButtonContainer'>
          <BiSolidEraser className='reactIcon' size="46" onClick={handleEraser}/>
          <ImBin className="reactIcon" size="36" onClick={clearCanvas}/>
        </div>
      </div>
      <canvas ref={canvasRef} width={850} height={480} />
    </div>
  );
};

export default Paint;
